import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  IonAccordion,
  IonAccordionGroup,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
} from "@ionic/react";

import { close, closeOutline, person, personOutline } from "ionicons/icons";
import CustomDesplegable from "../../components/basicsComponents/CustomDesplegable/CustomDesplegable";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { Button, Card, Typography } from "@mui/joy";
import { LibraryAdd, LibraryAddOutlined, Person } from "@mui/icons-material";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import useTituloPagina from "../../hooks/tituloPagina";

export default function HorariosPrestadores() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [especialidades, setEspecialidades] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [abrirDesplegableEspecialidades, setAbrirDesplegableEspecialidades] =
    useState(false);
  const [horario, setHorario] = useState([]);
  const [horarios, setHorarios] = useState(null);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const traerHorariosPrestador = async (prestador) => {
    let horarios = null;
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    try {
      if (prestador !== -1) {
        const response = await axios.get(
          `${urlAxioPP}PrestadoresHorarios/${prestador}`,
          config
        );
        if (response.data.length !== 0) {
          horarios = response.data[0];
        } else {
          horarios = [];
        }
        setHorario(horarios);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar los horarios del prestador",
        "rojo"
      );
    }
  };

  const traerHorariosEspecialidad = async (prestadores) => {
    let arrayHorarios = [];
    let arrayHorariosMostrar = [];
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    try {
      if (prestadores.length > 0) {
        const response = await axios.get(
          `${urlAxioPP}PrestadoresHorarios`,
          config
        );
        if (response.data.length > 0) {
          arrayHorarios = response.data.map((horario) => {
            // Modificar las propiedades de los horarios
            for (const key in horario) {
              if (
                horario.hasOwnProperty(key) &&
                typeof horario[key] === "string" &&
                horario[key].startsWith("De ")
              ) {
                horario[key] = horario[key].replace("De ", "");
              }
            }
            return horario;
          });
          arrayHorarios.forEach((horario) => {
            prestadores.forEach((prestador) => {
              if (prestador.codigo === horario.prestador)
                arrayHorariosMostrar.push(horario);
            });
          });
        } else {
          arrayHorarios = [];
        }

        for (const key in horario) {
          if (
            horario.hasOwnProperty(key) &&
            typeof horario[key] === "string" &&
            horario[key].startsWith("De ")
          ) {
            horario[key] = horario[key].replace("De ", "");
          }
        }

        setHorario(arrayHorariosMostrar);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar los horarios del prestador",
        "rojo"
      );
    }
  };

  const traerEspecialidades = async (paciente) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = [];
      }
      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true
      );

      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar las especialidades registradas",
        "rojo"
      );
    }
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config
      );
      if (response.data.length !== 0) {
        prestadores = response.data;
      } else {
        prestadores = null;
      }

      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true
      );

      let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
      prestadores = prestadores.filter((prestador) => {
        if (prestador.filtroEdad) {
          if (prestador.edadDesde <= edad <= prestador.edadHasta)
            return prestador;
        } else {
          return prestador;
        }
      });

      prestadores = prestadores.map((prestador) => {
        return {
          ...prestador,
          text: prestador.nombre,
        };
      });

      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar cargar los/las prestadores/as registrados/as",
        "rojo"
      );
    }
  };

  const CargarDesplegables = async (sesion) => {
    await traerPrestadores(sesion);
    await traerEspecialidades(sesion);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        CargarDesplegables(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const handleChangeSelect = (value, select) => {
    setCargando(true);
    switch (select) {
      case "Especialidad":
        setHorario([]);
        setEspecialidadSeleccionada(value);
        if (value !== -1) {
          let arrayPrestadores = prestadores.filter(
            (prestador) =>
              prestador.especialidad === value ||
              prestador.especialidad2 === value ||
              prestador.especialidad3 === value
          );
          setListadoPrestadores(arrayPrestadores);
          traerHorariosEspecialidad(arrayPrestadores);
        } else {
          setListadoPrestadores(prestadores);
          setPrestadorSeleccionado(-1);
        }
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
    setCargando(false);
  };

  const handleClickReservarTurnoPrestador = (prestador) => {
    history.push({
      pathname: "/portal/Reservar turno",
      state: { prestador: prestador },
    });
  };

  const renderTurnosLista = () => {
    return (
      <>
        <Row
          style={{ textAlign: "start" }}
          alignItems="stretch"
          container
          spacing={2}
          paddingInline={2}
        >
          {horario.length > 0 &&
            horario
              .filter(
                (prestador) =>
                  prestador.lunesM !== "" ||
                  prestador.lunesT !== "" ||
                  prestador.martesM !== "" ||
                  prestador.martesT !== "" ||
                  prestador.miercolesM !== "" ||
                  prestador.miercolesT !== "" ||
                  prestador.juevesM !== "" ||
                  prestador.juevesT !== "" ||
                  prestador.viernesM !== "" ||
                  prestador.viernesT !== "" ||
                  prestador.sabadoM !== "" ||
                  prestador.sabadoT !== "" ||
                  prestador.domingoM !== "" ||
                  prestador.domingoT !== ""
              )
              .map((prestador, i) => (
                <Column xs={12} md={6} xl={4}>
                  <Card
                    style={{ textAlign: "start", padding: "6px 16px" }}
                    key={prestador.codigo}
                  >
                    <Row
                      alignItems="center"
                      sx={{ padding: "0px", width: "100%" }}
                      container
                    >
                      <Column xs={12} sx={{ padding: "0px" }}>
                        <CustomInput
                          fullWidth
                          margin="normal"
                          startDecorator={
                            <React.Fragment>
                              <Button
                                type="button"
                                variant="plain"
                                color="neutral"
                                sx={{ color: "#B50009", paddingLeft: "4px" }}
                              >
                                <Person />
                                <Typography
                                  level="title-sm"
                                  sx={{ color: "#B50009" }}
                                >{` ${prestador.prestadorNom}`}</Typography>
                              </Button>
                            </React.Fragment>
                          }
                          endDecorator={
                            <React.Fragment>
                              <Button
                                type="button"
                                variant="plain"
                                color="neutral"
                                sx={{ color: "#B50009", paddingRight: "4px" }}
                                onClick={() =>
                                  handleClickReservarTurnoPrestador(
                                    prestador.prestador
                                  )
                                }
                              >
                                <Typography
                                  level="title-sm"
                                  sx={{ color: "#B50009" }}
                                >
                                  {`Reservar turno`.toUpperCase()}
                                </Typography>
                                <LibraryAdd />
                              </Button>
                            </React.Fragment>
                          }
                          type="button"
                          variant="plain"
                          value=" "
                          disabled
                          sx={{ paddingLeft: "0px", fontWeight: "5px" }}
                        />
                      </Column>
                    </Row>
                    <Row alignItems="center" container>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.lunesM === "" &&
                          prestador.lunesT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Lun: ${
                            prestador.lunesM === ""
                              ? prestador.lunesT === ""
                                ? ""
                                : prestador.lunesT
                              : prestador.lunesM +
                                (prestador.lunesT === ""
                                  ? ""
                                  : " - " + prestador.lunesT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.martesM === "" &&
                          prestador.martesT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Mar: ${
                            prestador.martesM === ""
                              ? prestador.martesT === ""
                                ? ""
                                : prestador.martesT
                              : prestador.martesM +
                                (prestador.martesT === ""
                                  ? ""
                                  : " - " + prestador.martesT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.miercolesM === "" &&
                          prestador.miercolesT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Mier: ${
                            prestador.miercolesM === ""
                              ? prestador.miercolesT === ""
                                ? ""
                                : prestador.miercolesT
                              : prestador.miercolesM +
                                (prestador.miercolesT === ""
                                  ? ""
                                  : " - " + prestador.miercolesT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.juevesM === "" &&
                          prestador.juevesT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Jue: ${
                            prestador.juevesM === ""
                              ? prestador.juevesT === ""
                                ? ""
                                : prestador.juevesT
                              : prestador.juevesM +
                                (prestador.juevesT === ""
                                  ? ""
                                  : " - " + prestador.juevesT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.viernesM === "" &&
                          prestador.viernesT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Vier: ${
                            prestador.viernesM === ""
                              ? prestador.viernesT === ""
                                ? ""
                                : prestador.viernesT
                              : prestador.viernesM +
                                (prestador.viernesT === ""
                                  ? ""
                                  : " - " + prestador.viernesT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.sabadoM === "" &&
                          prestador.sabadoT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Sab: ${
                            prestador.sabadoM === ""
                              ? prestador.sabadoT === ""
                                ? ""
                                : prestador.sabadoT
                              : prestador.sabadoM +
                                (prestador.sabadoT === ""
                                  ? ""
                                  : " - " + prestador.sabadoT)
                          }`}
                        </Typography>
                      </Column>
                      <Column
                        xs={12}
                        sm={6}
                        xl={4}
                        hidden={
                          prestador.domingoM === "" &&
                          prestador.domingoT === "" &&
                          false
                        }
                      >
                        <Typography level="body-xs">
                          {`Dom: ${
                            prestador.domingoM === ""
                              ? prestador.domingoT === ""
                                ? ""
                                : prestador.domingoT
                              : prestador.domingoM +
                                (prestador.domingoT === ""
                                  ? ""
                                  : " - " + prestador.domingoT)
                          }`}
                        </Typography>
                      </Column>
                    </Row>
                  </Card>
                </Column>
              ))}
        </Row>
      </>
    );
  };

  return (
    <>
      {/*Desplegable con filtros*/}
      <div slot="content">
        {/*Filtros*/}
        <IonGrid>
          <Row>
            <Column xs={12}>
              <IonItem>
                <CustomDesplegable
                  array={especialidades}
                  value={especialidadSeleccionada}
                  handleChange={handleChangeSelect}
                  mostrarTodos={false}
                  mostrarSearch={true}
                  placeholder="Seleccione una sucursal..."
                  label="Sucursal"
                  id="Especialidad"
                  isOpen={abrirDesplegableEspecialidades}
                  setIsOpen={setAbrirDesplegableEspecialidades}
                  variant="plain"
                />
              </IonItem>
            </Column>
          </Row>
        </IonGrid>
      </div>
      {horario.length > 0 && renderTurnosLista()}

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
